export default "__VITE_ASSET__CZnYVrLv__"